import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorld = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-world",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.6 9h16.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.6 15h16.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.5 3a17 17 0 0 0 0 18" }),
		/* @__PURE__ */ _jsx("path", { d: "M12.5 3a17 17 0 0 1 0 18" })
	]
});
export default SvgWorld;
